// extracted by mini-css-extract-plugin
export default {"row":"MultilineCell_row__6AGOI","zero":"MultilineCell_zero__YPhwv","placeHolderShimmer":"MultilineCell_placeHolderShimmer__Li42K"};